(() => {
  const drawer = document.getElementById('CartDrawer');
  const body = document.getElementById('CartDrawerBody');

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style:'currency', currency:'USD' }).format(cents / 100);
  }

  function renderCart(cart) {
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-cart">Your cart is empty.<br><br><a class="btn btn--dark" href="/collections/all">Continue shopping</a></div>';
      return;
    }
    body.innerHTML = `
      ${cart.items.map(item => `
        <div class="cart-line">
          <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">
          <div>
            <h3>${escapeHtml(item.product_title)}</h3>
            <p>Qty ${item.quantity}</p>
            <p>${money(item.final_line_price)}</p>
          </div>
          <button class="icon-btn" data-remove="${item.key}" aria-label="Remove item">×</button>
        </div>
      `).join('')}
      <div class="cart-total"><span>Total</span><span>${money(cart.total_price)}</span></div>
      <a class="btn btn--dark btn--full" href="/checkout">Checkout</a>
    `;
    body.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:btn.dataset.remove, quantity:0})
        });
        const updated = await getCart();
        renderCart(updated);
        updateCounts(updated.item_count);
      });
    });
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  }

  async function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    renderCart(await getCart());
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
  }

  document.addEventListener('click', async e => {
    const open = e.target.closest('[data-cart-open]');
    const close = e.target.closest('[data-cart-close]');
    const add = e.target.closest('[data-add-to-cart]');

    if (open) {
      e.preventDefault();
      openCart();
    }
    if (close) closeCart();

    if (add) {
      e.preventDefault();
      const form = add.closest('form');
      const data = new FormData(form);
      add.disabled = true;
      add.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Accept':'application/json'},
          body:data
        });
        if (!res.ok) throw new Error('Add to cart failed');
        const cart = await getCart();
        updateCounts(cart.item_count);
        await openCart();
      } catch (err) {
        alert('Could not add this item. Please try again.');
      } finally {
        add.disabled = false;
        add.textContent = 'Add to cart';
      }
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(btn => {
      btn.addEventListener('click', () => {
        main.src = btn.dataset.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(x => x.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  });

  // Quantity controls
  document.querySelectorAll('[data-quantity]').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-minus]').addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value) - 1);
    });
    wrap.querySelector('[data-plus]').addEventListener('click', () => {
      input.value = Number(input.value) + 1;
    });
  });
})();
/* Color-aware product gallery: automatic swipe, arrows, dots and Orange/Gray selection. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-color-gallery]').forEach(initColorGallery);
  document.querySelectorAll('[data-foldaro-product-form]').forEach(initFoldaroVariantForm);
});

function initColorGallery(gallery){
  const main = gallery.querySelector('[data-gallery-main]');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const finishButtons = [...gallery.querySelectorAll('[data-color-select]')];
  const dotsWrap = gallery.querySelector('[data-gallery-dots]');
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  let color = 'Orange';
  let current = 0;
  let timer;

  function visible(){
    return thumbs.filter(t => t.dataset.color === color);
  }

  function buildDots(){
    dotsWrap.innerHTML = '';
    visible().forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery-dot' + (i === current ? ' is-active' : '');
      b.setAttribute('aria-label', `Image ${i + 1}`);
      b.addEventListener('click', () => { go(i); restart(); });
      dotsWrap.appendChild(b);
    });
  }

  function go(n){
    const list = visible();
    if (!list.length) return;
    current = (n + list.length) % list.length;
    const active = list[current];
    main.src = active.dataset.src;
    thumbs.forEach(t => t.classList.remove('is-active'));
    active.classList.add('is-active');
    gallery.querySelectorAll('.gallery-dot').forEach((d, i) => d.classList.toggle('is-active', i === current));
  }

  function setColor(nextColor){
    color = nextColor;
    current = 0;
    finishButtons.forEach(b => b.classList.toggle('is-active', b.dataset.colorSelect === color));
    buildDots();
    go(0);
    restart();
    const matchingVariantButton = document.querySelector(
      `[data-foldaro-product-form] [data-value="${CSS.escape(color)}"]`
    );
    matchingVariantButton?.click();
  }

  function restart(){
    clearInterval(timer);
    timer = setInterval(() => go(current + 1), 4500);
  }

  finishButtons.forEach(b => b.addEventListener('click', () => setColor(b.dataset.colorSelect)));
  prev?.addEventListener('click', () => { go(current - 1); restart(); });
  next?.addEventListener('click', () => { go(current + 1); restart(); });
  gallery.addEventListener('mouseenter', () => clearInterval(timer));
  gallery.addEventListener('mouseleave', restart);

  buildDots();
  go(0);
  restart();
}

function initFoldaroVariantForm(form){
  const dataEl = form.querySelector('[data-variants-json]');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const buttons = [...form.querySelectorAll('.variant-button')];
  const idInput = form.querySelector('[data-variant-id]');
  const price = form.closest('.product-info')?.querySelector('[data-product-price]');
  const selected = {};

  buttons.forEach(button => {
    const option = button.dataset.option;
    const value = button.dataset.value;
    if (button.classList.contains('is-selected')) selected[option] = value;

    button.addEventListener('click', () => {
      selected[option] = value;
      buttons.filter(x => x.dataset.option === option).forEach(x => x.classList.remove('is-selected'));
      button.classList.add('is-selected');

      const variant = data.find(v =>
        Object.entries(selected).every(([name, val]) => {
          const idx = v.option_names.indexOf(name);
          return idx >= 0 && v.options[idx] === val;
        })
      );

      if (variant) {
        idInput.value = variant.id;
        if (price) price.textContent = variant.price_formatted;
      }
    });
  });
}
